import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface ILocationListCheckboxes {
	label?: string;
	value?: string;
	id?: string;
}

export interface ILocationListCheckboxFilter {
	heading?: string;
	checkboxes?: ILocationListCheckboxes[];
}

export interface ILocationListOptions {
	label?: string;
	value?: string;
}

export interface ILocationListSelects {
	label?: string;
	id?: string;
	options: ILocationListOptions[];
	relations: any[];
}

export interface ILocationListSelectFilter {
	heading?: string;
	selects: ILocationListSelects[];
}

export interface ILocationListFilterProps extends IBaseElementProps {
	state?: any;
	byProgramCodeURL?: string;
	checkboxFilter?: ILocationListCheckboxFilter;
	selectFilter?: ILocationListSelectFilter;
	filteredMinistries?: any[];
	onCheck?: (checkboxSelection: string) => void;
	onSelect?: (filterName: string, filterValue: string) => void;
}

const LocationListFilter: React.FC<ILocationListFilterProps> = ({
	state,
	byProgramCodeURL,
	checkboxFilter,
	selectFilter,
	filteredMinistries,
	onCheck,
	onSelect,
}) => {
	const handleCheckboxSelection = (checkboxValue: string) => {
		if (onCheck) {
			onCheck(checkboxValue);
		}
	};

	const handleFilterSelection = (filterName, filterValue) => {
		if (onSelect) {
			onSelect(filterName, filterValue);
		}
	};

	return (
		<div className="location-list__filter">
			{checkboxFilter?.checkboxes && (
				<fieldset className="location-list__fieldset">
					<legend className="location-list__legend">
						{checkboxFilter?.heading}
					</legend>
					{checkboxFilter.checkboxes.map((checkbox, index) => (
						<div key={index} className="location-list__checkbox">
							<label>
								<input
									onClick={() => {
										handleCheckboxSelection(
											checkbox?.value,
										);
									}}
									type="checkbox"
									value={checkbox?.value}
									checked={
										state?.programCategories?.indexOf(
											checkbox?.value.toString(),
											0,
										) > -1
									}
								/>
								<span>{checkbox?.label}</span>
							</label>
						</div>
					))}
				</fieldset>
			)}
			{selectFilter?.selects && (
				<fieldset className="location-list__fieldset">
					<legend className="location-list__legend">
						{selectFilter?.heading}
					</legend>
					{selectFilter.selects.map((select, index) => (
						<div key={index} className="location-list__select">
							<label htmlFor={select?.id}>{select?.label}</label>
							{select?.options && (
								<select
									onChange={(e) => {
										handleFilterSelection(
											select?.id,
											e.target.value,
										);
									}}
									id={select?.id}
									value={
										state?.[select?.id] == null
											? ''
											: state?.[select?.id]
									}
								>
									<option value={''}>{select?.label}</option>
									{select?.id == 'ministry_select' &&
									filteredMinistries
										? filteredMinistries?.map(
												(option, index) => (
													<option
														key={index}
														value={option?.value}
													>
														{option?.label}
													</option>
												),
										  )
										: select?.options.map(
												(option, index) => (
													<option
														key={index}
														value={option?.value}
													>
														{option?.label}
													</option>
												),
										  )}
								</select>
							)}
							<span></span>
						</div>
					))}
				</fieldset>
			)}
		</div>
	);
};

export default LocationListFilter;
